<template>
    <a-select
        :showSearch='true'
        label-in-value
        v-model:value="value"
        :placeholder="title"
        style="width: 250px"
        :filter-option="false"
        :not-found-content="fetching ? undefined : null"
        option-label-prop="label"
        @search="fetchUser"
        @change='change'
        allowClear

    >
        <template v-if="fetching" v-slot:notFoundContent>
            <a-spin size="small" />
        </template>
        <a-select-option v-for="d in data" :key="d.name" :value="d.name" :label="d.name">
            <div class='row_content'>
                <div> {{ d.name }}</div>
                <div style='color:#1abc9c'> {{ d.pinyin }}</div>
            </div>
           
        </a-select-option>
  </a-select>
       
</template>
<script>
import commonApi from '@axios/common'
import { ref } from 'vue'
export default {
    componentname: "selectStationList",
    props:{
        title:{
            type:String,
            default:'始发站'
        },
    },
    setup(props,context){
        let fetching = ref(false);
        let value = ref(undefined);
        let data = ref([])
        
        const fetchUser = ( value ) => {
            let params = {
                name : value,
                currentPage : 1,
                size : 20
            }
            fetching.value = true;
            commonApi.station(params).then((res)=>{
                data.value = res
                fetching.value = false;
            }).catch(()=>{
                fetching.value = false;
            })
        }

        const change = (value) => {
            console.log(value)
            context.emit('setValue',{
                title : props.title,
                val : value?value.key:''
            });
        }

        fetchUser();

        return {
            change,
            fetchUser,
            fetching,
            value,
            data
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .row_content{
        display: flex;
        justify-content: space-between;
    }
   
  
</style>
